import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "./styles/App.scss";
import LandingPage from "./components/LandingPage";
import { Route, Routes, useLocation } from "react-router-dom";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import GoToTop from "./components/GoToTop";
import Admin from "./components/Admin";
import Terms from "./components/Terms";
import Booking from "./components/Booking";
import PaymentResult from "./components/PaymentResult";
import MobileContactBar, {
  shouldShowMobileContactBar,
} from "./components/MobileContactBar";
import Footer from "./components/Footer";

function App() {
  const { pathname } = useLocation();
  const showContactBar = shouldShowMobileContactBar(pathname);

  return (
    <div className={`App ${showContactBar ? "hasMobileContactBar" : ""}`}>
      <Navbar />

      <div className="siteContent">
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/booking/:carId" element={<Booking />} />
          <Route path="/payment/result" element={<PaymentResult />} />
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </div>
      <Footer />
      {showContactBar && <MobileContactBar />}
      <GoToTop />
    </div>
  );
}

export default App;
